import { Component, Input, SimpleChanges } from '@angular/core';
import { EnodeService } from 'src/app/services/enode/enode.service';
import {
  EnodeVehicle,
  SmartChargingStatus
} from 'src/app/services/enode/enode.types';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-smart-charge-override',
  templateUrl: './smart-charge-override.component.html',
  styleUrls: ['./smart-charge-override.component.scss']
})
export class SmartChargeOverrideComponent {
  @Input() vehicle: EnodeVehicle;
  @Input() smartChargeStatus: SmartChargingStatus;

  hasSmartChargePlan: boolean;
  chargeFailed = false;
  resumeFailed = false;
  isOverridden = false;
  planOverridden = false;
  isCharging = false;
  resumingPlan = false;

  constructor(private _enodeService: EnodeService) {}

  ngOnInit() {
    if (
      this.smartChargeStatus?.plan?.id &&
      this.smartChargeStatus?.plan?.startAt &&
      this.smartChargeStatus?.plan?.estimatedFinishAt
    ) {
      this.hasSmartChargePlan = true;
    }
    this.isCharging = this.vehicle.chargeState.isCharging;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (hasChanged([changes?.vehicle, changes?.smartChargeStatus])) {
      if (
        changes?.smartChargeStatus?.currentValue?.plan?.id &&
        changes?.smartChargeStatus?.currentValue?.plan?.startAt &&
        changes?.smartChargeStatus?.currentValue?.plan?.estimatedFinishAt
      ) {
        this.hasSmartChargePlan = true;
        if (
          changes?.smartChargeStatus?.currentValue?.state ===
          'PLAN:EXECUTING:OVERRIDDEN'
        ) {
          this.getVendorAction(
            changes?.smartChargeStatus?.currentValue?.smartOverride
              ?.vendorActionId
          );
          if (this.isCharging) {
            this.isOverridden = true;
          }
        }
        if (
          changes?.smartChargeStatus?.currentValue.state ===
          'PLAN:EXECUTING:STOPPING'
        ) {
          this.isOverridden = true;
          this.resumingPlan = true;
        }
      }
      if (changes?.vehicle?.currentValue) {
        this.isCharging =
          changes?.vehicle?.currentValue?.chargeState.isCharging;
      }
    }
  }

  smartChargeOverride() {
    this.planOverridden = true;
    this._enodeService.startCharging(this.vehicle.id).subscribe({
      next: (res) => {
        if (res?.failureReason?.detail) {
          this.chargeFailed = true;
          this.planOverridden = false;
        }
      },
      error: () => {
        this.chargeFailed = true;
        this.planOverridden = false;
      }
    });
  }

  resumeSmartCharge() {
    this.resumingPlan = true;
    this._enodeService.stopCharging(this.vehicle.id).subscribe({
      next: (res) => {
        if (res?.failureReason?.detail) {
          this.resumingPlan = false;
          this.resumeFailed = true;
        }
      },
      error: () => {
        this.resumeFailed = true;
        this.resumingPlan = false;
      }
    });
  }

  getVendorAction(id: string) {
    this._enodeService.getVendorAction(id).subscribe({
      next: (action) => {
        if (action.kind === 'START') {
          this.chargeFailed = false;
          switch (action.state) {
            case 'PENDING':
              this.planOverridden = true;
              break;
            case 'CONFIRMED':
              this.isOverridden = true;
              break;
            case 'FAILED':
              this.chargeFailed = true;
              break;
            default:
              break;
          }
        } else if (action.kind === 'STOP') {
          switch (action.state) {
            case 'PENDING':
              this.resumingPlan = true;
              break;
            case 'CONFIRMED':
              this.isOverridden = false;
              this.resumeFailed = false;
              break;
            case 'FAILED':
              this.resumeFailed = true;
              break;
            default:
              break;
          }
        }
      }
    });
  }
}
